import React, { Fragment, useState } from 'react';
import GLedgerListView from '../../../components/account/setup/general_ledger/GLedgerListView';
import AppURL from '../../../constants/AppURL';
import useFetchData from '../../../helpers/useFetch';

const GeneralLedgerListView = () => {
    const [onURL, setOnURL] = useState(AppURL.AccountURL + 'account/general/ledger/list/view/');
    const { data, loading, error, refetch } = useFetchData(onURL);

    const handleFormSuccess = ():void => {
        refetch(); // Recall the API to fetch the latest data
    };
    return (
        <Fragment>
            <GLedgerListView data={data} handleFormSuccess={handleFormSuccess} loading={loading} error={error} />
        </Fragment>
    )
}

export default GeneralLedgerListView